import {combineReducers} from "redux";
import themeReducer from "./themeReducer";
import postReducer from "./postReducer";

export default combineReducers({
    theme: themeReducer,
    post: postReducer,
});